/**
 * What a member sees when they open the hub without access to it.
 *
 * ⚠️ THIS REPLACED A SILENT REDIRECT, AND THE PERSON WHO FOUND IT WAS THE ONE
 * EVALUATING THE PRODUCT. Kylie, 2026-09-08, clicking "Commercial Hub" from
 * COMM-PASS before Josh had provisioned her: "it just clicks, it doesn't … it
 * just takes me back to Compass", and then "mine is saying it's not found". The
 * route returned `<Navigate to="/" replace />`, so an un-entitled member was
 * dropped back where they started with no error, nothing in the console, and no
 * way to tell a permissions decision from a broken link. She read it as broken,
 * which is the correct reading of that behaviour.
 *
 * ⚠️ IT SAYS NOTHING ABOUT WHAT EXISTS BEHIND THE GATE. No module names, no
 * "your agency has X but not Y" — the entitlement detail is the server's and
 * telling somebody what they are missing is both a sales problem and an
 * information leak. It says: you do not have this, here is who turns it on,
 * here is the way back.
 *
 * ⚠️ AND "NOT SIGNED IN" IS A DIFFERENT ANSWER FROM "NOT ENTITLED". Treating
 * them the same would tell an anonymous COMM-PASS agent that they lack access to
 * something they have never been offered, and send them chasing a grant when all
 * they needed was to sign in.
 */
import { Link } from 'react-router-dom';

export function HubNoAccess({ signedIn }: { signedIn: boolean }): JSX.Element {
  return (
    <div className="wrap">
      <div className="na-card">
        <h1>{signedIn ? 'The Commercial Hub is not switched on for you yet' : 'Sign in to open the Commercial Hub'}</h1>

        {signedIn ? (
          <>
            <p>
              Your sign-in worked — this is an access question, not a broken link. The hub is turned
              on per agency, and yours has not been enabled for it yet.
            </p>
            <p className="na-how">
              To get it switched on, speak to your Agents Alliance contact or email{' '}
              {/*
                The address members already write to for hub questions. A mailto
                rather than a form: a form would need a table, a notification and
                somebody watching it, and none of that exists yet — an unanswered
                request would be worse than no request.
              */}
              <a href="mailto:commpass@agentsalliance.biz?subject=Commercial%20Hub%20access">
                commpass@agentsalliance.biz
              </a>
              .
            </p>
          </>
        ) : (
          <p>
            Use the sign-in button at the top of the page. The hub needs an account; COMM-PASS
            submissions do not, which is why you can use those without one.
          </p>
        )}

        {/*
          The way back, said plainly. She arrived here from COMM-PASS and the old
          behaviour returned her there automatically — the difference is that
          this time it is her decision and she knows why.
        */}
        <p className="na-back">
          <Link to="/">Back to COMM-PASS</Link>
        </p>
      </div>
    </div>
  );
}
